module.exports = __webpack_public_path__ + "img/contacto2.87a6c5fb.png";